import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';

import { VacationScheduleMyDeadlineResponse } from '@app/gen/vacations';
import { CreateEventRequest, CreateEventResponse } from '@app/gen/events';

import { GetDeadlineDto } from '../dto';

@injectable()
export class AbsencesService {
  constructor(
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
  ) {}

  async getVacationScheduleDeadline(dto: GetDeadlineDto) {
    const result = await this.unmarshaller.unmarshall(
      await this.http.get(
        `/vacation/schedule/${dto.companyId}/my_deadline`,
        {},
        { withSide: true },
      ),
      VacationScheduleMyDeadlineResponse,
    );

    return result;
  }

  async createEventFromAbsence({
    event_type_id,
    employee_id,
    attributes,
  }: CreateEventRequest) {
    const response = await this.unmarshaller.unmarshall(
      await this.http.post(
        '/event',
        {
          event_type_id,
          employee_id,
          attributes,
        },
        { withSide: true },
      ),
      CreateEventResponse,
    );

    return {
      event_id: response.event_id,
    };
  }
}
